import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './UnhidePosting.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnhidePostingMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type UnhidePostingMutation = (
  { __typename?: 'Mutation' }
  & { postingsUnhidePosting?: Types.Maybe<(
    { __typename?: 'PostingsPostingMutationResult' }
    & { success?: Types.Maybe<(
      { __typename?: 'PostingsPosting' }
      & Pick<Types.PostingsPosting, 'id'>
    )>, error?: Types.Maybe<(
      { __typename?: 'PostingsError' }
      & Pick<Types.PostingsError, 'message' | 'details'>
    )> }
  )> }
);


export type UnhidePostingMutationFn = Apollo.MutationFunction<UnhidePostingMutation, UnhidePostingMutationVariables>;

/**
 * __useUnhidePostingMutation__
 *
 * To run a mutation, you first call `useUnhidePostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnhidePostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unhidePostingMutation, { data, loading, error }] = useUnhidePostingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnhidePostingMutation(baseOptions?: Apollo.MutationHookOptions<UnhidePostingMutation, UnhidePostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnhidePostingMutation, UnhidePostingMutationVariables>(Operations.unhidePosting, options);
      }
export type UnhidePostingMutationHookResult = ReturnType<typeof useUnhidePostingMutation>;
export type UnhidePostingMutationResult = Apollo.MutationResult<UnhidePostingMutation>;
export type UnhidePostingMutationOptions = Apollo.BaseMutationOptions<UnhidePostingMutation, UnhidePostingMutationVariables>;